// Modules
import { useEffect, useState } from "react";

// Properties
import { CallProperties } from "./call.properties"
import { useTranslation } from "react-i18next";
import { CountdownComponent } from "../countdown/countdown.component";
import { UserType } from "../../../../types/user.type";
import { appEventEmitter } from "../../../../context/EventContext";
import { on } from "events";

// Assets
const boopSfx = require('./call.mp3');

/**
 * Call Component
 * @description Component to show the call
 * @param {CallProperties} properties
 * @returns {JSX.Element}
 */
export function CallComponent(properties: CallProperties): JSX.Element {

    // translation function
    const { t } = useTranslation();

    // Get logged user
    const user: UserType = properties.user;

    const [canRecord, setCanRecord] = useState<boolean>(false);

    useEffect(() => {

    }, []);

    useEffect(() => {
      const userGroups = user?.users_groups;

      if (userGroups) {
        const canRecord = userGroups.some((group) => group?.group?.record_activated === false);
        setCanRecord(!canRecord);
      }
    }, []);

    /**
     * Accepted Call
     */
    const acceptedCall = async () => {
      properties.setAnsweredCall(true);
      properties.acceptCall(properties.call);
      localStorage.setItem('localCall', 'false');
      // emit call accepted
      properties.socket.emit('call:accepted', {
          room: properties.call.room,
          user: properties.user,
          author: properties.call.available,

      })

      await appEventEmitter.emit("call:accepted", {
        action: "accept",
        resource: "call",
        agent: properties.user.id,
        event_phase: "start",
        caller: properties.call.available.user.id,
        user: properties.user,
      });

      // set room to call
      properties.setRoom(properties.call.room)
      setTimeout(async () => {
          properties.socket.joinRoom(properties.call.room)

          // Register Mindray credentials for Electron clients
          properties.onRoomJoined?.(properties.call.room);

          await appEventEmitter.emit("room:joined", {
            action: "join",
            resource: "room",
            agent: properties.call.room,
            event_phase: "start",
            room: properties.call.room,
            user: properties.user,
          });

          properties.setCall(undefined)
      }, 1000)
    }

    /**
     * Rejected Call
     */
    const rejectedCall = async () => {
      properties.socket.emit('call:rejected', {
        room: properties.call.room,
        available: properties.call.available,
      });

      await appEventEmitter.emit("call:rejected", {
        action: "reject",
        resource: "call",
        agent: properties.user.id,
        event_phase: "end",
        caller: properties.call.available.user.id,
        user: properties.user,
      });

      properties.rejectCall(properties.call);
    }

    const ringTone = () => {
      // emit audio notification
      const audio = new Audio(boopSfx);
      audio.play();

      setTimeout(() => {
        // repeat audio notification
        const audio = new Audio(boopSfx);
        audio.play();
      }, 1000);
    }

    const onCallReceive = async () => {
      await appEventEmitter.emit("call:incoming", {
        action: "receive",
        resource: "call",
        agent: properties.user.id,
        event_phase: "start",
        caller: properties.call.available.user.id,
        user: properties.user,
      });
    }

    useEffect(() => {
      onCallReceive();
      ringTone();

      // Wait 2 seconds to repeat audio notification
      const ringInterval = setInterval(() => {
        ringTone();
      }, 3000);

        return () => {
            clearInterval(ringInterval);
        }

    }, []);

    return <div className="CallComponent Modal Right" style={{
        right: 0,
        left: 'auto'
    }}>
        <div className='Header'>
            {t('call.title')} de {properties?.call?.available?.user?.name} {properties?.call?.available?.user?.surnames}
        </div>

        <div style={{
            color: '#666',
            padding: 25, fontSize: 18, marginTop: 25, borderLeft: '4px solid #ddd', marginLeft: 25
        }}>
            {t('call.message')}

            {
              canRecord && <div className="rec-info">
                <i className="las la-exclamation-triangle"></i>
                <p>{t('call.rec.info')}</p>
              </div>
            }
        </div>

        <div style={{
            margin: 25, marginTop: 0
        }}>
            <button className="Submit" disabled={!properties.devicesLoaded} onClick={acceptedCall}>
                {t('call.accept')}
                {
                    user.user_setting?.auto_call && properties.call !== undefined ? (
                    properties.devicesLoaded && <CountdownComponent time={user.user_setting?.auto_call_timeout} onFinish={acceptedCall} />
                    ) : ("")
                }
            </button>
            <div className="Submit secondary" onClick={rejectedCall}>
                {t('call.reject')}
            </div>
        </div>
    </div>
}
